<script setup lang="ts">
import { computed, ref } from 'vue'

import { useStore } from '@/store'

const store = useStore()

const demoModeEnabled = computed(() => store.getters.flatSancareSettings['demo_mode'])
const stayList = computed(() => store.state.automation.automationStayList.items)
const automationGroupId = computed(() => Number(store.state.route.query.automationGroupId))
const selectedStayIds = computed(() => store.state.stayList.selectedStayIds)
const selectedStaysCount = computed(() => selectedStayIds.value.length)
const label = computed(() => `Valider ${selectedStaysCount.value > 0 ? `(${selectedStaysCount.value})` : 'la page'}`)

const emit = defineEmits<{
  (e: 'refresh-staylist')
}>()

const showValidationDropdown = ref(false)

function validateAutomatableStays() {
  // No selection = validate the stays currently displayed on the page (bounded batch)
  const stayIds = selectedStayIds.value.length
    ? selectedStayIds.value
    : stayList.value.map((stay) => stay.id)
  store.dispatch('validateAutomatableSelection', { automationGroupId: automationGroupId.value, stayIds }).then(() => {
    emit('refresh-staylist')
  })
  showValidationDropdown.value = false
}
</script>

<template>
  <v-dropdown
    :shown="showValidationDropdown"
    @hide="showValidationDropdown = false"
  >
    <div
      v-if="automationGroupId && !demoModeEnabled"
      class="btn sancare-btn rounded-end"
      :class="{ disabled: !stayList.length }"
      @click="showValidationDropdown = true"
    >
      {{ label }}
    </div>
    <template #popper>
      <div class="p-3">
        <div class="title-light text-center mb-2">
          <h4>
            Êtes-vous sûr(e) ?
          </h4>
          <span>Cette action est irréversible</span>
        </div>
        <div class="text-center">
          <button
            class="btn btn-danger btn-padded"
            @click="validateAutomatableStays"
          >
            Confirmer
          </button>
        </div>
      </div>
    </template>
  </v-dropdown>
</template>
